import 'devextreme/ui/popup'
import 'devextreme/ui/toolbar'

import { COMPONENT_NAME as ORDER_ADD_COMPONENT_NAME, OrderAddComponent } from './add-order/add-order.component'
import { COMPONENT_NAME as COMPLETE_ORDER_COMPONENT_NAME, CompleteOrderComponent } from './complete-order/complete-order.component'
import { COMPONENT_NAME as ORDER_VALIDATION_COMPONENT_NAME, OrderValidationComponent } from './complete-order/components/validation/order-validation.component'
import { COMPONENT_NAME as ORDER_SEARCH_BY_SERIAL_NBR_COMPONENT_NAME, OrderSearchBySerialNbrComponent } from './search-by-serial-nbr/order-search-by-serial-nbr.component'
import { COMPONENT_NAME as CONFIRM_ORDER_COMPONENT_NAME, ConfirmOrderComponent } from './confirm-order/confirm-order.component'
import { COMPONENT_NAME as CONFIRM_ORDER_DEPOSITORY_COMPONENT_NAME, ConfirmOrderDepositoryComponent } from './confirm-order/components/confirm-order-depository/confirm-order-depository.component'
import { COMPONENT_NAME as CONFIRM_ORDER_CREATE_ORDER_COMPONENT_NAME, ConfirmOrderCreateOrderComponent } from './confirm-order/components/confirm-order-create-order/confirm-order-create-order.component'

import { OrderCreateEditDirective } from './create-edit/orders-create-edit.directive'
import { OrderDetailsDirective } from './details/orders-details.directive'

export const COMPONENTS_MODULE_NAME = 'simax.orders.components'
export const CREATE_EDIT_DIRECTIVE_NAME: string = 'orderCreateEdit'
export const DETAILS_DIRECTIVE_NAME: string = 'orderDetails'

const module = angular.module(COMPONENTS_MODULE_NAME, [])

module.component(ORDER_SEARCH_BY_SERIAL_NBR_COMPONENT_NAME, new OrderSearchBySerialNbrComponent())
module.component(COMPLETE_ORDER_COMPONENT_NAME, new CompleteOrderComponent())
module.component(ORDER_ADD_COMPONENT_NAME, new OrderAddComponent())
module.component(ORDER_VALIDATION_COMPONENT_NAME, new OrderValidationComponent())
module.component(CONFIRM_ORDER_COMPONENT_NAME, new ConfirmOrderComponent())
module.component(CONFIRM_ORDER_DEPOSITORY_COMPONENT_NAME, new ConfirmOrderDepositoryComponent())
module.component(CONFIRM_ORDER_CREATE_ORDER_COMPONENT_NAME, new ConfirmOrderCreateOrderComponent())

module.directive(DETAILS_DIRECTIVE_NAME, [() => new OrderDetailsDirective()])
module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new OrderCreateEditDirective()])
